import { ChoiceGroup, DatePicker, DayOfWeek, IChoiceGroupOption } from '@fluentui/react';
import dateformat from 'dateformat';

import { datepickerStrings } from '../../../../../App/dateformat';
import shipmentStatuses from '../../../../../shared/shipment-statuses.json';
import { actions, useFormSelector } from '../../../slice';

export default () => {
  const editingFormId = useFormSelector((state) => state.editingFormId);
  const shipmentInfo = useFormSelector((state) => state.shipmentInfo);
  const selectorInfo = shipmentStatuses.find(
    (x) => x.key == shipmentInfo?.status
  );

  const defaultStartDate = editingFormId ? undefined : new Date();

  return (
    <>
      <ChoiceGroup
        options={options}
        selectedKey={shipmentInfo?.status}
        onChange={(_, option) => option && actions.setShipmentType(option.key)}
      />
      {selectorInfo?.selectors?.includes("date") && (
        <DatePicker
          isRequired
          value={
            shipmentInfo?.dateTimestamp
              ? new Date(shipmentInfo.dateTimestamp)
              : undefined
          }
          onSelectDate={(date) =>
            date && actions.setShipmentDateTimestamp(date.getTime())
          }
          formatDate={(date) => dateformat(date, "dddd dd/mm/yyyy")}
          firstDayOfWeek={DayOfWeek.Monday}
          isMonthPickerVisible={false}
          strings={datepickerStrings}
          label="Teslim Tarihi"
          minDate={defaultStartDate}
        />
      )}

      {selectorInfo?.selectors?.includes("date-start") && (
        <DatePicker
          isRequired
          value={
            shipmentInfo?.dateStartTimestamp
              ? new Date(shipmentInfo.dateStartTimestamp)
              : undefined
          }
          onSelectDate={(date) =>
            date && actions.setShipmentStartDateTimestamp(date.getTime())
          }
          formatDate={(date) => dateformat(date, "dddd dd/mm/yyyy")}
          firstDayOfWeek={DayOfWeek.Monday}
          isMonthPickerVisible={false}
          strings={datepickerStrings}
          label="En Erken Teslim Tarihi"
          minDate={defaultStartDate}
        />
      )}

      {selectorInfo?.selectors?.includes("date-end") && (
        <DatePicker
          isRequired
          value={
            shipmentInfo?.dateEndTimestamp
              ? new Date(shipmentInfo.dateEndTimestamp)
              : undefined
          }
          onSelectDate={(date) =>
            date && actions.setShipmentEndDateTimestamp(date.getTime())
          }
          formatDate={(date) => dateformat(date, "dddd dd/mm/yyyy")}
          firstDayOfWeek={DayOfWeek.Monday}
          isMonthPickerVisible={false}
          strings={datepickerStrings}
          label="En Geç Teslim Tarihi"
          minDate={
            shipmentInfo?.dateStartTimestamp
              ? new Date(shipmentInfo.dateStartTimestamp)
              : defaultStartDate
          }
          disabled={
            !shipmentInfo?.dateStartTimestamp &&
            selectorInfo?.selectors?.includes("date-start")
          }
        />
      )}
    </>
  );
};

const options: (IChoiceGroupOption & { selectors?: string[] })[] =
  shipmentStatuses.map((info) => ({
    key: info.key,
    text: info.text,
    iconProps: { iconName: info.iconName },
  }));
